import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-310">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 w-full z-50 md:hidden bg-brand-dark/95 backdrop-blur-md border-t border-gold/20 p-4 pb-safe shadow-[0_-10px_30px_rgba(0,0,0,0.5)]" data-id="element-311">
          <CTAButton href="#pricing" className="shadow-gold-glow" data-id="element-312">
            → VER OFERTAS AHORA
          </CTAButton>
        </motion.div>}
    </AnimatePresence>;
}